<template>
	<div id="Bigcoffeegatheringdetails" class="centert">
		<div style="position: fixed;bottom: 5px;right: 50px;width: 50px;height: 50px;background-color: red;color: #FFF;z-index: 2;line-height: 50px;text-align: center;"
			@click="fha">
			返回
		</div>
		<!-- 头标签 -->
		<dpubtop></dpubtop>
		<!-- 中间 -->
		<div class="Bigcoffdetails">
			<!-- 头部 -->
			<div class="pub_pub">
				<div class="pub_title">
					<div class="img_logo">
						<img src="../../../imges/lebiao/zjzk.png" alt="">
					</div>
					<div class="title_t">
						<div class="imhg_ti">
							<img src="../../../imges/lebiao/zjzk_font.png" alt="">
						</div>
						<div class="sm_t">
							<div style="float:left"><span>招聘</span><span style="color:#D7230C;">求职</span></div>
							<div class="sm_pub">海量职位、人才</div>
						</div>
					</div>
				</div>
				<div style="width: 0px;height: 36px;border: 1px solid #ececec;float: left;">
					<!-- 中间线 -->
				</div>
				<div class="ckgd_dh">
					<div class="sy">
						<div class="sy_img">
							<img src="../../../imges/details/sy.png" alt="">
						</div>
						<router-link class="sy_title" to="/" style="text-decoration: none;
							">首页</router-link>
					</div>
					<div class="jt" style="margin-top: 0px;">
						<img src="../../../imges/details/jt.png" alt="">
					</div>
					<div class="name">人才招聘</div>
				</div>
			</div>
			<!-- 头部结束 -->
			<div class="top_bottom">
				<div class="top_bottom_T">
					<div class="dtiail_warp">
						<!-- <div style="width: 95%;margin-left: 1%;height: 150px;margin-top: 10px;">
							<div style="width: 60%;height: 150px;float: left;">
								<div style="height: 50px;font-size: 20px;font-weight: 800;line-height: 25px;">
									{{title}}
								</div>
								<div style="height: 40px;line-height: 20px;">
									更新：{{getLocalTime(contents.create_time)}} <span>&nbsp;&nbsp;&nbsp;</span> 浏览：
									{{contents.view}}人<span>&nbsp;&nbsp;&nbsp;</span> 申请： {{contents.replynum}}人
								</div>
								<div style="height: 50px;width: 150px;float: left;">
									<div style="width: 70px;height: 30px;border: 1px solid #ececec;text-align: center;line-height: 30px;"
										v-if="contents.xueli=='1'">
										无要求
									</div>
									<div style="width: 70px;height: 30px;border: 1px solid #ececec;text-align: center;line-height: 30px;"
										v-else-if="contents.xueli=='5'">
										博士
									</div>
									<div style="width: 70px;height: 30px;border: 1px solid #ececec;text-align: center;line-height: 30px;"
										v-else-if="contents.xueli=='4'">
										硕士
									</div>
									<div style="width: 70px;height: 30px;border: 1px solid #ececec;text-align: center;line-height: 30px;"
										v-else-if="contents.xueli=='3'">
										本科
									</div>
									<div style="width: 70px;height: 30px;border: 1px solid #ececec;text-align: center;line-height: 30px;"
										v-else-if="contents.xueli=='2'">
										专科
									</div>
								</div>
								<div
									style="width: 100px;height: 30px;border: 1px solid #ececec;text-align: center;line-height: 30px;float: left;">
									{{contents.jinyan}}年以上
								</div>
							</div>
							<div style="width: 100px;height:60px;float: right;box-shadow: rgb(0, 0, 0) 2px 4px 6px;">
								<img v-lazy="contents.zhanshi_img" style="width: 100%;height: 100%;" alt="">
							</div>
						</div> -->
						<div style="width:100%;height:50px;margin-top:15px;">
							<div style="height: 50px;font-size: 20px;font-weight: 800;line-height: 25px;">
								{{contents.title}}
							</div>
						</div>
						<div style="width:100%;height:120px;">
							<div style="width: 150px;height:120px;box-shadow: rgb(0, 0, 0) 2px 4px 6px;float:left;">
								<img v-lazy="contents.zhanshi_img" style="width: 100%;height: 100%;" alt="">
							</div>
							<div style="width: 300px;height:120px;float:left;margin-left: 20px;padding-left: 10px;">
								<div style="width: 100%;height: 30px;line-height: 30px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">公司名称:{{contents.enterprise}}</div>
								<div style="width: 100%;height: 30px;line-height: 30px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">人事部联系人:{{contents.name}}</div>
								<div style="width: 100%;height: 30px;line-height: 30px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">电话:{{contents.phone}}</div>
								<div style="width: 100%;height: 30px;line-height: 30px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">邮箱:{{contents.email}}</div>
							</div>
							<div style="width: 400px;height:120px;float:left;margin-left: 20px;">
								<div style="width: 100%;height: 30px;line-height: 30px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">职位:{{contents.title}}</div>
								<div style="width: 100%;height: 30px;line-height: 30px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">薪酬:¥{{contents.money}}</div>
								<div style="width: 100%;height: 30px;line-height: 30px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">公司规模:{{contents.scope}}</div>
								<div style="width: 100%;height: 30px;line-height: 30px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">工作性质:{{contents.work_type}}</div>
							</div>
						</div>
						<div style="width: 95%;margin-left: 1%;height: 50px;margin-top: 30px;">
							<div style="width: 10px;height: 20px;background-color: #D7230C;float: left;">

							</div>
							<div
								style="width: 140px;height: 20px;line-height: 20px;font-size: 18px;font-weight: 800;float: left;margin-left: 20px;">
								公司招聘详情
							</div>
						</div>
						<div style="width: 95%;margin-left: 1%;"
							v-html="contents.content">

						</div>
						<div style="width: 95%;margin-left: 1%;height: 50px;margin-top: 30px;">
							<div style="width: 10px;height: 20px;background-color: #D7230C;float: left;">
						
							</div>
							<div
								style="width: 140px;height: 20px;line-height: 20px;font-size: 18px;font-weight: 800;float: left;margin-left: 20px;">
								公司福利待遇
							</div>
						</div>
						<div style="width: 95%;margin-left: 1%;">
							{{contents.fuli}}
						</div>
					</div>
					<div style="width: 95%;margin: 0 auto;height: 50px;margin-top: 20px;border-top: 1px dashed #DDD;">
						<!-- <Xguanyuedu></Xguanyuedu> -->
						<!-- 打赏分享 -->
						<!-- <tabmore :price="0" nologin_type="xptj" name="新品推荐" :tid="$route.query.id"></tabmore> -->
						<div @click="sca"
							style="width: 50px;height: 70px;text-align: center;float: left;margin-left: 35%;">
							<img class="scname" src="../../../imges/dsdsdsds/shoucang1.png" style="width: 100%;height: 50px;" alt="">
							<div style="width: 100%;height: 20px;line-height: 20px;text-align: center;">
								收藏
							</div>
						</div>
						<div  @click="getShareInfo"
							style="width: 50px;height: 70px;text-align: center;float: left;margin-left: 20px;">
							<img class="scname" src="../../../imges/dsdsdsds/weixin1.png" style="width: 100%;height: 50px;" alt="">
							<div style="width: 100%;height: 20px;line-height: 20px;text-align: center;">
								微信
							</div>
						</div>
						<div @click="fxkj"
							style="width: 50px;height: 70px;text-align: center;float: left;margin-left: 20px;">
							<img class="scname" src="../../../imges/dsdsdsds/qqkongjian1.png" style="width: 100%;height: 50px;" alt="">
							<div style="width: 100%;height: 20px;line-height: 20px;text-align: center;">
								空间
							</div>
						</div>
						<div @click="das"
							style="width: 50px;height: 70px;text-align: center;float: left;margin-left: 20px;border-radius: 50%;">
							<img class="scname" src="../../../imges/dsdsdsds/dashang1.png"
								style="width: 100%;height: 50px;" alt="">
								<div style="width: 100%;height: 20px;line-height: 20px;text-align: center;">
									打赏
								</div>
						</div>
					</div>
					<div style="width: 95%;margin-left: 1%;height: 50px;margin-top: 30px;">
						<div style="width: 10px;height: 20px;background-color: #D7230C;float: left;">

						</div>
						<div
							style="width: 100px;height: 20px;line-height: 20px;font-size: 18px;font-weight: 800;float: left;margin-left: 20px;">
							推荐职位
						</div>
					</div>

					<router-link tag="div" :to="{ path:'/qzzpdetailist',query:{id:item,title:item.title} }"
						v-for="(item,index) in qwqs" :key="index"
						style="width: 97%;margin-top: 10px;margin-left: 1%;border: 1px solid #ececec;height: 170px;position: relative;">
						<div style="height: 30px;font-size: 20px;font-weight: 800;margin-top: 10px;margin-left: 10px;">
							{{item.title}}
						</div>
						<div style="height: 30px;margin-left: 10px;margin-top: 10px;">
							{{item.title}} <img src="../../../imges/rz.png" alt=""
								style="width: 18px;height: 20px;margin-left: 10px;margin-right: 10px;" /> {{item.scope}}
						</div>
						<div style="height: 30px;font-size: 14px;margin-top: 10px;margin-left: 10px;">
							经验：{{item.jobexperience}} | 公司规模：{{item.scope}} | 工作性质：{{item.work_type}}人 
						</div>

						<div
							style="width: 150px;height: 40px;border: 1px solid #D7230C;border-radius: 5px;line-height: 40px;text-align: center;font-weight: 800;color: #D7230C;position: absolute;right: 10px;bottom: 50px;">
							查看简历
						</div>
					</router-link>
				</div>
				<!-- 侧边栏 -->
				<div class="top_bottom_B">
					<rightlist></rightlist>
				</div>
			</div>


		</div>
		<dashang ref="child" :dsje="dsje"></dashang>
		<div class="popContainer" v-show="isShowQR" @click="gbgb">
			<vue-qr style="display: inline-block;
		position: absolute;
		top: 40%;
		left: 40%;" :logoSrc="imageUrl" :text="Text" :size="200"></vue-qr>
		</div>
		<!-- 中间结束 -->
		<!-- 尾标签 -->
		<myfooter></myfooter>
	</div>
</template>

<script>
	import http from "@/utils/http";
	import vueQr from 'vue-qr'
	export default {
		data() {
			return {
				options: [],
				imageUrl: 'https://img1.baidu.com/it/u=3311948344,2093308219&fm=253&fmt=auto&app=138&f=PNG?w=500&h=500',
				searchData: {
					type: '职位',
					keyword: '' //搜索框查询关键字
				},
				Text: '',
				letData: true,
				isShowQR: false, //二维码显示
				value: '',
				id: this.$route.query.id,
				title: this.$route.query.title,
				mid: this.$route.query.mid,
				contents: '',
				dsje: [{
					tid: this.$route.query.id,
					nologin_type: 'rczp',
					name: '人才招聘打赏',
					price: 0,
				}],
				qwqs: '',
			}
		},
		methods: {
			getLocalTime(nS) {
				return new Date(parseInt(nS) * 1000).toLocaleDateString().replace(/:\d{1,2}$/, ' ');
			},
			fha() {
				console.log('返回上一层')
				this.$router.go(-1); //返回上一层
			},
			das() {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				if (loginInfo) {
					this.$refs.child.isShowZF = true //修改子组件data
				} else {
					this.$router.replace('/login')
				}
			},
			gbgb() {
				this.isShowQR = false
				// $('#qrCodeUrl').html = ''
			},
			fxkj() {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				if (loginInfo) {
					const share = {
						title: this.contents.title,
						desc: "海工人|船海智造360°综合服务平台",
						image_url: [this.contents.picture],
						share_url: "https://www.shipoe360.com/#" + this.$route.path + '?id=' + this.id  
					};
					//跳转地址
					location.replace(
						"https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=" +
						encodeURIComponent(share.share_url) +
						"&title=" +
						share.title +
						"&pics=" +
						share.image_url.join("|") +
						"&summary=" +
						share.desc
					);
				} else {
					this.$router.replace('/login')
				}
			},
			getShareInfo() {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				if (loginInfo) {
					if (this.letData) {
						let myhref = window.location.href
						// console.log(myhref)
						// this.Text = myhref
						this.isShowQR = true
						this.letData = false
					} else {
						this.isShowQR = true
					}
				} else {
					this.$router.replace('/login')
				}
			},
			async sca() {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				let res = await http.post('api/picture/personal_collection', {
					uid: loginInfo.id,
					title: this.contents.title,
					picture: this.contents.picture,
					pc_link: this.$route.path + '?id=' + this.id + '&title=' + this.title,
					url_link: this.$route.path + '?id=' + this.id + '&title=' + this.title,
				})
				if (res.data.code == 200) {
					this.$notify({
						title: '成功',
						message: '收藏成功',
						type: 'success'
					});
				} else {
					this.$notify({
						title: '失败',
						message: res.data.msg,
						type: 'error'
					});
				}
			},
		},
		async mounted() {
			let res = await http.get('index.php/bscard/wxapp.Sorts')
			this.options = res.data.data

			let res1 = await http.post('api/picture/recruit_message', {
				id: this.id,
			})
			this.contents = res1.data.data[0]
			console.log(this.contents)
			this.$axios({
				url: 'https://admin.shipoe360.com/api/Common/index',
				method: 'post',
				params: {
					model: 'hr',
					type: 'content',
					mid: '9',
					rows_limit: '1'
				}
			}).then((res) => {
				console.log(res)
				this.qwqs = res.data.data.list.data
				console.log(this.qwqs)
			})


		},
		components: {
			// 尾标签,
			myfooter: resolve => require(['@/components/myfooter'], resolve),
			// 头标签
			dpubtop: resolve => require(['@/components/dpubtop/dpubtop'], resolve),
			//测标签
			rightlist: resolve => require(['@/components/dpubtop/rightList.vue'], resolve),
			//广澳
			PCguangao: resolve => require(['@/components/dpubtop/PCguangao.vue'], resolve),
			//相关阅读
			Xguanyuedu: resolve => require(['@/components/dpubtop/xgyd.vue'], resolve),
			vueQr,
			dashang: resolve => require(['@/components/dashang/dashang.vue'], resolve),
		}
	}
</script>

<style scoped>
	.centert {
		width: 1200px;
		margin: 0 auto;
	}

	.Bigcoffdetails {
		width: 100%;
	}

	.pub_pub {
		margin-top: 20px;
		border-radius: 0px !important;
		height: 36px;
	}

	.pub_title {
		width: 350px;
		float: left;
	}

	.ctu_::after,
	.pub_title::after {
		content: '';
		display: block;
		clear: both;
	}

	.pub_title>img {
		width: 100%;
		height: 100%;
	}

	.img_logo {
		float: left;
		width: 36px;
		height: 36px;
		overflow: hidden;
	}

	.title_t {
		float: left;
		height: 36px;
		margin-left: 12px;
		font-weight: 600;
		letter-spacing: 3px;
	}

	.imhg_ti {
		height: 12px;
		width: 120px;
		margin-top: -5px;
	}

	.imhg_ti>img {
		width: 100%;
		height: 100%;
	}

	.sm_t {
		height: 26px;
		line-height: 26px;
		font-size: 18px;
		margin-top: 8px;
	}

	.sm_pub {
		float: left;
		margin-left: 12px;
		font-size: 12px;
		color: #5e5d5d;
		cursor: pointer;
	}

	.sy::after,
	.ckgd_dh::after {
		content: '';
		display: block;
		clear: both;
	}

	.ckgd_dh {
		float: left;
		font-size: 12px;
		margin-left: 50px;
	}

	.ckgd_dh>div {
		float: left;
		height: 40px;
		line-height: 42px;
		color: #5e5d5d;
	}


	.name {
		line-height: 43px;
	}

	.sy_img {
		float: left;
		width: 20px;
		height: 20px;
	}

	.sy_img>img {
		margin-top: 13px;
		width: 100%;
		height: 100%;
	}

	.jt>img {
		margin-top: 10px;
	}

	.sy_title {
		float: left;
		height: 40px;
		line-height: 44px;
		margin-left: 6px;
		color: #5e5d5d;
	}

	.jt {
		width: 12px;
		height: 20px;
		margin-left: 6px;
		margin-right: 6px;
	}


	/* 头部结束 */
	.top_bottom {
		width: 100%;
		height: 100%;
		clear:both;
		overflow:hidden;
		box-shadow: #6e6e6e 0px 0px 10px;
		margin-top: 30px;
	}

	.top_bottom_T {
		width: 80%;
		float: left;
	}

	.top_bottom_B {
		width: 20%;
		float: left;
	}

	.dtiail_warp {
		width: 95%;
		margin: 0 auto;
	}

	.dtiail_title {
		margin-top: 40px;
		margin-bottom: 16px;
		text-align: center;
		font-size: 22px;
		color: #c00e0e;
	}

	.cont_dtiail>>>p>>>img {
		width: auto;
		height: 100%;
	}

	.cont_dtiail {
		overflow: hidden;
		margin-top: 20px;
		min-height: 300px;
	}
	
	.popContainer{
		position: fixed;
		    top: 0;
		    left: 0;
		    right: 0;
		    bottom: 0;
		    z-index: 999;
		    background: rgba(0, 0, 0, 0.6);
	}
</style>
